import { render } from "./S281614.vue?vue&type=template&id=46535f86"
const script = {}
script.render = render

export default script